import React from 'react';
import diaHelper from '../../../helpers/diaHelper';
import {ANNOTATION_HAVE_TITLE} from '../../../constants/dia';
import {FormattedMessage} from 'react-intl';

const OrderedAnnotations = ({annotations, annoLink, trim}) => {
  let body = [];
  let items = [];
  let lastType = null;
  let previousSection = {
    type: null,
    category: null,
    annotations: []
  };
  annotations.forEach(anno => {
    let type = anno.attributes.annotation_type;
    let category = anno.attributes.category || null;
    if (!lastType) {
      lastType = type;
      previousSection.category = category;
      items.push({type: type});
      previousSection.type = type;
    }
    if (type !== lastType) {
      items.push(previousSection);
      items.push({type: type});
      previousSection = {
        type: type,
        category: category,
        annotations: []
      };
      lastType = type;
    } else if (category !== previousSection.category) {
      items.push(previousSection);
      previousSection = {
        type: type,
        category: category,
        annotations: []
      };
    }
    previousSection.annotations.push(anno);
  });
  if (lastType) {
    items.push(previousSection);
  }
  items.forEach(item => {
    if (!item.annotations) {
      body.push(<h2 key={item.type}><FormattedMessage key={`title_${item.type}`} id={item.type}/></h2>);
    } else {
      body.push(createPanel(item.annotations, item.category ? <span className="panel-title">{item.category}</span> : null, item.category || `nocat_${item.type}`, item => {
        return createBody(item, ANNOTATION_HAVE_TITLE.indexOf(item.attributes.annotation_type) >= 0);
      }));
    }
  });

  return (<div>{body}</div>);

  function createPanel(items, title, key, body) {
    let panel = [];
    items.forEach((item, index) => {
      if (index > 0) {
        panel.push(<hr key={`hr_${index}`}/>);
      }
      panel.push(body(item));
    });
    return (<div key={key} className="panel-clean panel panel-default">{title ? <div className="annotation-category">{title}</div> : <div className="annotation-category"/>}
      <div className="panel-body">{panel}</div>
    </div>);
  }

  function createBody(item, title) {
    let more = annoLink(item.id);
    return (<div key={item.id}>
      <div>
        {title ? <h3 dangerouslySetInnerHTML={{__html: item.attributes.label}}/> : ''}
        {trim ? (<div className={item.attributes.body.replace(/<[^>]+>/g, '').length > 300 ? "bottom-shadow-white" : ''} style={{maxHeight: 100, overflowY: "hidden"}}
                      dangerouslySetInnerHTML={{__html: diaHelper.formatAnnotationBody(item.attributes.body)}}/>) : (
          <div dangerouslySetInnerHTML={{__html: diaHelper.formatAnnotationBody(item.attributes.body)}}/>)}

      </div>
      {more}
    </div>);
    // TODO separate element?
    // TODO instead of fixed height -> after 3 paragraph/hX's
  }
};

OrderedAnnotations.propTypes = {
  annotations: React.PropTypes.array,
  annoLink: React.PropTypes.func,
  order: React.PropTypes.array,
  trim: React.PropTypes.bool
};

OrderedAnnotations.defaultProps = {
  trim: true,
  annoLink: () => {
    return null;
  }
};

export default OrderedAnnotations;



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/components/OrderedAnnotations.js
 **/